import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {reduxForm, getFormValues } from 'redux-form';

import { bookingFormInitialValues } from '../store/reducers';
import { setStep, submitReservation, setReservationStatus } from '../store/actions';
import {
	validateStep3FormValues,
	isContinueEnabled,
} from '../validators';
import {formatPrice, inIframe, postMessageToParent} from '../utils';
import { PAYMENT_METHOD_WITHOUT_PAYMENT } from '../constants';
import ReservationStatus from '../enums/ReservationStatus';
import withLocalize from '../withLocalize';
import T from './Translate';

class Navbar extends Component {

	state = {
		isFullscreenLoading: false,
		isNavbarInitialized: false,
	};

	componentWillReceiveProps(nextProps) {
		if (this.props.recaptchaToken !== nextProps.recaptchaToken) {
			this.recaptchaDidResolve(nextProps.recaptchaToken);
		}
	}

	recaptchaDidResolve = async (token) => {
		const { dispatch } = this.props;

		try {
			const response = await dispatch(submitReservation(token));

			if (response.paymentGateway && response.paymentGateway.url) {
				// Přesměrování na platební bránu
				if (response.paymentGateway.inline && window._gopay !== undefined) {
					// inline varianta
					if (inIframe()) {
						postMessageToParent('redirectGopayInline', {
							gatewayUrl: response.paymentGateway.url,
							scriptUrl: response.paymentGateway.scriptUrl
						});
					} else if (window._gopay !== undefined) {
						window._gopay.checkout({gatewayUrl: response.paymentGateway.url, inline: true});
					} else {
						window.top.location.href = response.paymentGateway.url;
					}
				} else {
					window.top.location.href = response.paymentGateway.url; // nechceme případně zůstat v iframe
				}

			} else {
				if (response.errors) {
					const errors = Object.keys(response.errors);

					if (!errors[0]) {
						console.error("Server vrátil neočekávanou odpověď.", response);
					}

					dispatch(setReservationStatus(errors[0]));

				} else if (response.redirect && response.redirect.code === 200) {
					// Úspěšná rezervace
					if (response.redirect.url) {
						window.location.href = response.redirect.url;
					} else {
						dispatch(setReservationStatus(ReservationStatus.NO_GATE));
					}

				} else {
					console.error("Musí se ošetřit všechny návratové hodnoty.", response);
					dispatch(setReservationStatus(ReservationStatus.ERROR));
				}

				this.props.recaptcha.reset();
				this.setState({isFullscreenLoading: false});
				dispatch(setStep(5));
			}

		} catch (e) {
			console.error("Rezervace se nezdařila", e);
			this.props.recaptcha.reset();
			this.setState({isFullscreenLoading: false});
			dispatch(setReservationStatus(ReservationStatus.ERROR));
			dispatch(setStep(5));
		}
	};

	handleClickContinue = () => {

		const { dispatch, step, formValues, isPaymentGatewayEnabled, translate: t } = this.props;

		if (step === 1 && !isContinueEnabled(formValues, step)) {
			window.alert(t('Navbar.continueError.step1'));
			return;

		} else if (step === 2 && !isContinueEnabled(formValues, step)) {
			window.alert(t('Navbar.continueError.step2'));
			return;

		} else if (step === 3) {
			validateStep3FormValues(formValues);

		} else if (step === 4 && !isContinueEnabled(formValues, step, isPaymentGatewayEnabled)) {
			window.alert(t('Navbar.continueError.step4'));
			return;
		}

		const newStep = step + 1;

		if (newStep === 5) {
			this.setState({ isFullscreenLoading: true });
			this.props.recaptcha.execute();

		} else {
			dispatch(setStep(newStep));
		}


	};

	handleClickGoBack = (e) => {
		e.preventDefault();

		const { dispatch, step } = this.props;
		const newStep = step - 1;

		dispatch(setStep(newStep));
	};

	onNavbarInit = (el) => {
		if (el && !this.state.isNavbarInitialized) {
			this.setState({ isNavbarInitialized: true });
			this.navbarEl = el;
			postMessageToParent('navbarHeight', el.getBoundingClientRect().height);

			window.addEventListener('message', (e) => {
				this.onParentScroll(e);
			});
		}
	};

	onParentScroll = (e) => {
		if (e.data && e.data.type === 'scroll') {
			this.navbarEl.style.top = e.data.value + 'px';
			this.navbarEl.style.bottom = 'initial';
		}
	};

	getLabels = () => {
		const {
			step,
			isPaymentGatewayEnabled,
			formValues,
			isAdvancePaymentRequired,
			translate: t,
		} = this.props;

		let totalPriceLabel = t('Navbar.totalPriceLabel');
		let continueButtonLabel = t('Navbar.continue');

		if (step === 4 && isPaymentGatewayEnabled &&
			(isAdvancePaymentRequired || formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT) ) {
			totalPriceLabel = t('Navbar.priceToPay');
			continueButtonLabel = t('Navbar.reserveAndPay');

		} else if (step === 4) {
			continueButtonLabel = t('Navbar.reserve');
		}

		return { continueButtonLabel, totalPriceLabel };
	};

	getPrice = () => {
		const { totalPrice, priceToPay, isAdvancePaymentRequired, advancePaymentPercentage, formValues } = this.props;

		const price = (isAdvancePaymentRequired || (advancePaymentPercentage < 100 && formValues.advancePaymentOnly)) && formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT ? priceToPay : totalPrice;

		return formatPrice(price, formValues.currency);
	};

	render() {
		const { handleSubmit, step, formValues, isPaymentGatewayEnabled } = this.props;

		if (step > 4) return null;

		const { continueButtonLabel, totalPriceLabel } = this.getLabels();

		return (
            <nav className="navbar" ref={ el => this.onNavbarInit(el) }>
				<div className="navbar__row">
					<div className="navbar__price-container">
						{totalPriceLabel}<br />
						<span className="navbar__price">{this.getPrice()}</span>
					</div>
					<div className="navbar__buttons-container">
						{step > 1 &&
						<button
							className="button navbar__button-back"
							onClick={this.handleClickGoBack}
						>
							<T id="Navbar.back" />
						</button>
						}
						<button
							className={`button navbar__button-next ${!isContinueEnabled(formValues, step, isPaymentGatewayEnabled) ? 'navbar__button-next--disabled' : ''}`}
							onClick={handleSubmit(this.handleClickContinue)}
						>
							{continueButtonLabel}
						</button>
					</div>
				</div>

				{this.state.isFullscreenLoading &&
				<div className="fullscreen-loader">
					<div className="loader loader--large"/>
				</div>
				}

            </nav>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	withRouter,
	connect((state) => ({
		step: state.app.step,
		formValues: getFormValues('bookingForm')(state),
		totalPrice: state.app.totalPrice,
		priceToPay: state.app.priceToPay,
		isPaymentGatewayEnabled: state.app.isPaymentGatewayEnabled,
		isAdvancePaymentRequired: state.app.isAdvancePaymentRequired,
		advancePaymentPercentage: state.app.advancePaymentPercentage,
	})),
	withLocalize,
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx